import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";

export function EditUserDialog({ editingUser, setEditingUser, editForm, setEditForm, handleUpdateUser, teams }) {
  return (
    <Dialog open={!!editingUser} onOpenChange={(open) => { if (!open) setEditingUser(null); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-[#0B1F3B]">Edit User: {editingUser?.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Name</Label>
            <Input value={editForm.name} onChange={(e) => setEditForm({...editForm, name: e.target.value})} data-testid="edit-user-name" />
          </div>
          <div className="space-y-2">
            <Label>Role</Label>
            <Select value={editForm.role} onValueChange={(v) => setEditForm({...editForm, role: v})}>
              <SelectTrigger data-testid="edit-user-role">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="learner">Learner</SelectItem>
                <SelectItem value="manager">Manager</SelectItem>
                <SelectItem value="admin">Admin</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Team</Label>
            <Select value={editForm.team_id || "none"} onValueChange={(v) => setEditForm({...editForm, team_id: v === "none" ? "" : v})}>
              <SelectTrigger data-testid="edit-user-team">
                <SelectValue placeholder="No team" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">No team</SelectItem>
                {teams.map(t => (
                  <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setEditingUser(null)}>Cancel</Button>
          <Button onClick={handleUpdateUser} className="bg-[#0B1F3B] hover:bg-[#0B1F3B]/90" data-testid="submit-edit-user">
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
